import "./LandingPage.css";
import Header from "../../components/Header/Header";
import { useNavigate } from "react-router-dom";
import { API_ENDPOINTS, PATH } from "../../utils/config/constants";

export const LandingPage = () => {
  const navigate = useNavigate();
  const windowsDownloadUrl = `${PATH}${API_ENDPOINTS.DESKTOP_DOWNLOAD}?platform=windows`;

  return (
    <main className="landing">
      <div className="landing__glow landing__glow_left" />
      <div className="landing__glow landing__glow_right" />

      <Header variant="public" />

      <section className="landing__hero">
        <div className="landing__content">
          <p className="landing__eyebrow">Neuro Boost</p>
          <h1 className="landing__title">NEURO BOOST ВАШ AI ПОМОЩНИК НА СОБЕСЕДОВАНИЯХ</h1>
          <p className="landing__subtitle">
            Neuro Boost — AI помощник, который помогает проходить IT собеседования и мгновенно
            генерирует ответы
          </p>

          <div className="landing__actions">
            <button className="landing__platform landing__platform_disabled" type="button" disabled>
              macOS · скоро
            </button>
            <a className="landing__platform" href={windowsDownloadUrl}>
              Windows
            </a>
          </div>

          <div className="landing__meta">
            <section className="landing__info-card">
              <h2 className="landing__card-title">Преимущества</h2>
              <ul className="landing__advantages">
                <li>✔ Моментальные ответы</li>
                <li>✔ База знаний</li>
                <li>✔ Настройка резюме</li>
              </ul>
            </section>

            <section className="landing__info-card">
              <h2 className="landing__card-title">Системные требования</h2>
              <div className="landing__requirements">
                <span>MacOS</span>
                <span>Windows</span>
              </div>
            </section>
          </div>
        </div>

        <aside className="landing__preview" aria-label="Предпросмотр интерфейса Neuro Boost">
          <div className="landing__preview-shell">
            <div className="landing__preview-header">
              <span className="landing__preview-badge">Interview assist</span>
              <span className="landing__preview-status">Ready</span>
            </div>

            <div className="landing__preview-card landing__preview-card_large">
              <div className="landing__preview-label">Prompt analysis</div>
              <div className="landing__preview-line landing__preview-line_long" />
              <div className="landing__preview-line" />
              <div className="landing__preview-line landing__preview-line_short" />
            </div>

            <div className="landing__preview-grid">
              <div className="landing__preview-card">
                <div className="landing__preview-label">Knowledge base</div>
                <div className="landing__preview-line" />
                <div className="landing__preview-line landing__preview-line_short" />
              </div>
              <div className="landing__preview-card">
                <div className="landing__preview-label">Resume tune</div>
                <div className="landing__preview-line" />
                <div className="landing__preview-line landing__preview-line_short" />
              </div>
            </div>

            <div className="landing__preview-terminal">
              <div className="landing__preview-dots">
                <span />
                <span />
                <span />
              </div>
              <div className="landing__preview-code">$ neuro_boost --interview live</div>
              <div className="landing__preview-code">$ response generated in 0.4s</div>
            </div>
          </div>
        </aside>
      </section>

      <footer className="landing__footer">
        <div className="landing__footer-inner">
          <div className="landing__footer-brand">
            <span className="landing__footer-logo">CODE CAREER</span>
            <p className="landing__footer-desc">AI помощник для подготовки к IT собеседованиям</p>
          </div>
          <nav className="landing__footer-links">
            <button type="button" onClick={() => navigate("/about")}>О продукте</button>
            <button type="button" onClick={() => navigate("/offer")}>Пользовательское соглашение</button>
            <button type="button" onClick={() => navigate("/privacy")}>Политика конфиденциальности</button>
            <button type="button" onClick={() => navigate("/refund")}>Правила возврата</button>
            <button type="button" onClick={() => navigate("/rights-holders")}>Информация для правообладателей</button>
            <button type="button" onClick={() => navigate("/contacts")}>Контакты и реквизиты</button>
          </nav>
          <p className="landing__footer-copy">
            © 2026 code-career. Все права защищены.
          </p>
        </div>
      </footer>
    </main>
  );
};
